// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AccordionScrollController from "./accordion_scroll_controller";
application.register("accordion-scroll", AccordionScrollController);

import Administration__Activitystream__CloseActivityReplyMonthController from "./administration/activitystream/close_activity_reply_month_controller";
application.register(
  "administration--activitystream--close-activity-reply-month",
  Administration__Activitystream__CloseActivityReplyMonthController,
);

import Administration__Apps__SortableTableController from "./administration/apps/sortable_table_controller";
application.register(
  "administration--apps--sortable-table",
  Administration__Apps__SortableTableController,
);

import Administration__EditCategoriesController from "./administration/edit_categories_controller";
application.register(
  "administration--edit-categories",
  Administration__EditCategoriesController,
);

import Administration__Groups__JoinRequestMessageController from "./administration/groups/join_request_message_controller";
application.register(
  "administration--groups--join-request-message",
  Administration__Groups__JoinRequestMessageController,
);

import Administration__Invites__SendBatchActionsController from "./administration/invites/send_batch_actions_controller";
application.register(
  "administration--invites--send-batch-actions",
  Administration__Invites__SendBatchActionsController,
);

import Administration__Invites__SentController from "./administration/invites/sent_controller";
application.register(
  "administration--invites--sent",
  Administration__Invites__SentController,
);

import Administration__Invites__ToggleBatchActionsController from "./administration/invites/toggle_batch_actions_controller";
application.register(
  "administration--invites--toggle-batch-actions",
  Administration__Invites__ToggleBatchActionsController,
);

import Administration__Newsletter__DragAndDropController from "./administration/newsletter/drag_and_drop_controller";
application.register(
  "administration--newsletter--drag-and-drop",
  Administration__Newsletter__DragAndDropController,
);

import Administration__Newsletter__IntervalController from "./administration/newsletter/interval_controller";
application.register(
  "administration--newsletter--interval",
  Administration__Newsletter__IntervalController,
);

import Administration__Newsletter__UnlayerFormController from "./administration/newsletter/unlayer_form_controller";
application.register(
  "administration--newsletter--unlayer-form",
  Administration__Newsletter__UnlayerFormController,
);

import Administration__Pages__SortableTableController from "./administration/pages/sortable_table_controller";
application.register(
  "administration--pages--sortable-table",
  Administration__Pages__SortableTableController,
);

import Administration__ProfileChangeRequests__SendBatchActionsController from "./administration/profile_change_requests/send_batch_actions_controller";
application.register(
  "administration--profile-change-requests--send-batch-actions",
  Administration__ProfileChangeRequests__SendBatchActionsController,
);

import Administration__ProfileChangeRequests__ToggleBatchActionsController from "./administration/profile_change_requests/toggle_batch_actions_controller";
application.register(
  "administration--profile-change-requests--toggle-batch-actions",
  Administration__ProfileChangeRequests__ToggleBatchActionsController,
);

import Administration__RoleAssignmentsController from "./administration/role_assignments_controller";
application.register(
  "administration--role-assignments",
  Administration__RoleAssignmentsController,
);

import Administration__TableauFilterController from "./administration/tableau_filter_controller";
application.register(
  "administration--tableau-filter",
  Administration__TableauFilterController,
);

import Administration__Teams__FallbackUpnAssignmentsController from "./administration/teams/fallback_upn_assignments_controller.jsx";
application.register(
  "administration--teams--fallback-upn-assignments",
  Administration__Teams__FallbackUpnAssignmentsController,
);

import AltchaController from "./altcha_controller";
application.register("altcha", AltchaController);

import AssignChannelSubscriptionsFormController from "./assign_channel_subscriptions_form_controller";
application.register(
  "assign-channel-subscriptions-form",
  AssignChannelSubscriptionsFormController,
);

import AuditLog__FilterController from "./audit_log/filter_controller";
application.register("audit-log--filter", AuditLog__FilterController);

import AutoAssignmentFormController from "./auto_assignment_form_controller";
application.register("auto-assignment-form", AutoAssignmentFormController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import EmailTwoFactorController from "./email_two_factor_controller";
application.register("email-two-factor", EmailTwoFactorController);

import ExternalActivitystreamsController from "./external_activitystreams_controller";
application.register(
  "external-activitystreams",
  ExternalActivitystreamsController,
);

import File__ValidateFileExtensionFilterListController from "./file/validate_file_extension_filter_list_controller";
application.register(
  "file--validate-file-extension-filter-list",
  File__ValidateFileExtensionFilterListController,
);

import Integrations__TableauEmbeddingController from "./integrations/tableau_embedding_controller";
application.register(
  "integrations--tableau-embedding",
  Integrations__TableauEmbeddingController,
);

import Invites__HandleExternalInviteController from "./invites/handle_external_invite_controller";
application.register(
  "invites--handle-external-invite",
  Invites__HandleExternalInviteController,
);

import MinistryController from "./ministry_controller";
application.register("ministry", MinistryController);

import PermissionPickerController from "./permission_picker_controller";
application.register("permission-picker", PermissionPickerController);

import Shared__AutosubmitController from "./shared/autosubmit_controller";
application.register("shared--autosubmit", Shared__AutosubmitController);

import Shared__GoBackButtonController from "./shared/go_back_button_controller";
application.register("shared--go-back-button", Shared__GoBackButtonController);

import Shared__LegalCheckboxesController from "./shared/legal_checkboxes_controller";
application.register(
  "shared--legal-checkboxes",
  Shared__LegalCheckboxesController,
);

import Shared__PasswordToggleController from "./shared/password_toggle_controller";
application.register(
  "shared--password-toggle",
  Shared__PasswordToggleController,
);

import Shared__PropertySetEditController from "./shared/property_set_edit_controller";
application.register(
  "shared--property-set-edit",
  Shared__PropertySetEditController,
);

import Shared__SelectAllController from "./shared/select_all_controller";
application.register("shared--select-all", Shared__SelectAllController);

import Shared__SortableTableController from "./shared/sortable_table_controller";
application.register("shared--sortable-table", Shared__SortableTableController);

import Shared__TabbarController from "./shared/tabbar_controller";
application.register("shared--tabbar", Shared__TabbarController);

import Shared__TimeagoController from "./shared/timeago_controller";
application.register("shared--timeago", Shared__TimeagoController);

import Shared__ToggleController from "./shared/toggle_controller";
application.register("shared--toggle", Shared__ToggleController);

import Shared__TranslationDropdownController from "./shared/translation_dropdown_controller";
application.register(
  "shared--translation-dropdown",
  Shared__TranslationDropdownController,
);

import TwoFactorAuthenticationsController from "./two_factor_authentications_controller";
application.register(
  "two-factor-authentications",
  TwoFactorAuthenticationsController,
);
